

























































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { NetSuiteCustomerContact } from "@/models/netsuite/netsuite";

@Component({
  components: {
    FormValidation
  }
})
export default class Contact extends Vue {
  @Prop() quote_name!: string;
  @Prop() first_name!: string;
  @Prop() last_name!: string;
  @Prop() company_name!: string;
  @Prop({ default: "" }) title!: string;
  @Prop() phone!: string;
  @Prop() email!: string;
  @Prop({ default: () => [] }) contacts!: NetSuiteCustomerContact[];
  @Prop({ default: true }) isNewCustomer!: boolean;
  @Prop({ default: false }) send_email!: boolean;

  protected selectedContactId: number | "new" | null = null;
  protected submitted = false;

  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    if (this.submitted) {
      this.validateForm();
    }
  }

  @Validations()
  validations() {
    return {
      first_name: { required },
      last_name: { required },
      quote_name: { required },
      ...(this.isNewCustomer ? { company_name: { required } } : {}),
      phone: { phone, required },
      email: { email, required }
    };
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
    EventBus.$on("saveQuote", this.validateForm);
    this.selectedContactId = "new";
  }

  @Watch("contacts")
  onContactsLoaded(contacts: NetSuiteCustomerContact[]): void {
    if (contacts.length === 1) {
      this.selectedContactId = contacts[0].id;
      this.onContactSelect();
    }
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
    EventBus.$off("saveQuote");
  }

  get sortedContacts(): NetSuiteCustomerContact[] {
    return [...this.contacts].sort((a, b) => {
      const nameA = [a.firstname, a.lastname]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      const nameB = [b.firstname, b.lastname]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      const hasNameA = nameA.length > 0;
      const hasNameB = nameB.length > 0;
      if (hasNameA !== hasNameB) return hasNameA ? -1 : 1;
      return (nameA || a.email.toLowerCase()).localeCompare(
        nameB || b.email.toLowerCase()
      );
    });
  }

  protected formatContactOption(contact: NetSuiteCustomerContact): string {
    const parts: string[] = [];
    const name = [contact.firstname, contact.lastname]
      .filter(Boolean)
      .join(" ");
    if (name) parts.push(name);
    if (contact.email) parts.push(contact.email);
    if (contact.phone) parts.push(contact.phone);
    return parts.join(" | ");
  }

  protected onContactSelect(): void {
    if (this.selectedContactId === "new" || !this.selectedContactId) {
      this.$emit("update:contact_id", null);
      this.updateItem("", "title");
      this.updateItem("", "first_name");
      this.updateItem("", "last_name");
      this.updateItem("", "phone");
      this.updateItem("", "email");
      return;
    }
    const contact = this.contacts.find(c => c.id === this.selectedContactId);
    if (!contact) return;
    this.$emit("update:contact_id", contact.id);
    this.updateItem(contact.title || "", "title");
    this.updateItem(contact.firstname || "", "first_name");
    this.updateItem(contact.lastname || "", "last_name");
    this.updateItem(contact.phone || "", "phone");
    this.updateItem(contact.email || "", "email");
  }

  protected validateForm(): void {
    this.submitted = true;
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "contact");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.submitted && this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
